import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const MarketPositionRateSettingCreate = () => (
  <Create
    transform={getTransform(
      [
        'market_id',
        'margin_percent_1099_guardrail',
        'payout_rate_percent_1099_guardrail',
        'incremental_margin_percent_1099',
        'margin_percent_w2_guardrail',
        'payout_rate_percent_w2_guardrail',
        'incremental_margin_percent_w2',
        'margin_percent_w2_travel_guardrail',
        'payout_rate_percent_w2_travel_guardrail',
      ],
      'settings',
    )}
  >
    <PositionRateSettingsForm settingsField="settings" />
  </Create>
);

export default MarketPositionRateSettingCreate;
